module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "contents"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h3', [_vm._v("Table of Contents")])]), _vm._v(" "), _c('h3', {
    staticClass: "sigil_not_in_toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0004"
    }
  }, [_vm._v("The Translator’s Foreword.")])]), _vm._v(" "), _c('h4', {
    staticClass: "sigil_not_in_toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0005"
    }
  }, [_vm._v("The Book of The Thousand Nights and a Night")])]), _vm._v(" "), _c('ol', [_c('li', [_c('a', {
    attrs: {
      "href": "#/Text/Section0005"
    }
  }, [_vm._v("Nur Al–Din Ali and the Damsel Anis Al–Jalis")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/Section0006"
    }
  }, [_vm._v("Tale of Ghanim bin Ayyub, the Distraught, the Thrall o’ Love.")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#/Text/Section0007"
    }
  }, [_vm._v("Tale of the First Eunuch, Bukhayt.")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tale of the Second Eunuch, Kafur.")])])])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tale of King Omar Bin Al–Nu’uman and his sons Sharrkan and Zau Al–Makan, and what befel them of things seld-seen and Peregrine.")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tale of Taj al-Muluk and the Princess Dunya (The Lover and the Loved).")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Section0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tale of Aziz and Azizah."), _c('br')])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0